__turbopack_context__.v({
  "infoText": "-jbu7a_infoText",
  "modal": "-jbu7a_modal",
});
